import { render } from "./Accordeon.vue?vue&type=template&id=09f7baad"
import script from "./Accordeon.vue?vue&type=script&lang=js"
export * from "./Accordeon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__